/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

type Props = {
    id?: string;
};

const FontColor: React.FC<Props> = (props): JSX.Element => {
    return (
        <section className="container flex flex-col">
            <div className="flex flex-col my-2 space-y-2">

                <div className="flex flex-col w-full">
                    <h2 className="text-lg py-2 text center font-semibold">
                        Typography
                    </h2>

                    <Tabs defaultValue="example">
                        <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
                            <TabsTrigger value="example">Example</TabsTrigger>
                            <TabsTrigger value="code">Code</TabsTrigger>
                        </TabsList>
                        <TabsContent value="example" className="p-8 w-10/12">
                            <div className="p-3">
                                <h2 className="font-extrabold md:text-4xl text-xl whitespace-nowrap">
                                    H2 The Quick White Fox....</h2>
                                <h2 className="font-extrabold md:text-4xl text-xl text-gradient-red whitespace-nowrap">
                                    H2 The Quick Red Fox....</h2>
                            </div>

                            <div>
                                <p className="max-w-xl text-white tracking-wider">
                                    Paragraph, The quick brown fox...</p>
                            </div>
                        </TabsContent>

                        <TabsContent value="code" className="p-8 w-10/12">
                            <div className="flex flex-col items-center px-6 whitespace-pre-line">

                                <code className="p-8 border rounded border-gray-600 w-full">
                                    {`
                                    <h2 className="font-extrabold md:text-4xl text-xl whitespace-nowrap">  
                                        H2 The Quick White Fox....  
                                    </h2>  
                                    
                                    <h2 className="font-extrabold md:text-4xl text-xl text-gradient-red whitespace-nowrap">  
                                        H2 The Quick Red Fox....  
                                    </h2>  

                                    <p className="max-w-xl text-white tracking-wider">  
                                        Paragraph, The quick brown fox  
                                    </p>  
                                    `} </code>

                            </div>
                        </TabsContent>
                    </Tabs>
                </div>

                <div className="flex flex-col w-full">
                    <h2 className="text-lg py-2 text center font-semibold">
                        Colours
                    </h2>

                    <Tabs defaultValue="example">
                        <TabsList className="grid w-full grid-cols-6 bg-gray-600 rounded ">
                            <TabsTrigger value="example">Example</TabsTrigger>
                            <TabsTrigger value="code">Code</TabsTrigger>
                        </TabsList>
                        <TabsContent value="example" className="p-8 w-10/12">
                            <div className="py-8 grid grid-cols-6 space-x-8 text-white">
                                <div>
                                    <div className="h-20 flex flex-col items-center justify-center font-medium w-24 bg-harvey-black border border-gray-600 rounded text-center">
                                        #1E1E1E
                                    </div>
                                    <span>Black</span>
                                </div>
                                <div>
                                    <div className="h-20 flex flex-col items-center justify-center font-medium w-24 bg-harvey-blue border border-gray-600 rounded text-center">
                                        #095796
                                    </div>
                                    <span>Blue</span>
                                </div>
                                <div>
                                    <div className="h-20 flex flex-col items-center justify-center font-medium w-24 bg-harvey-skyblue border border-gray-600 rounded text-center">
                                        #45a7f6
                                    </div>
                                    <span>Light Blue</span>
                                </div>
                                <div>
                                    <div className="h-20 flex flex-col items-center justify-center font-medium w-24 bg-harvey-red border border-gray-600 rounded text-center">
                                        #cb1829
                                    </div>
                                    <span>Red</span>
                                </div>
                                <div>
                                    <div className="h-20 flex flex-col items-center justify-center font-medium w-24 bg-gray-600 border border-gray-600 rounded text-center">
                                        #4B5563
                                    </div>
                                    <span>Dark Gray</span>
                                </div>
                                <div>
                                    <div className="h-20 flex flex-col items-center justify-center font-medium w-24 bg-gray-200 border border-gray-600 rounded text-center text-black">
                                        #E5E7EB
                                    </div>
                                    <span>Light Gray</span>
                                </div>
                            </div>
                        </TabsContent>

                        <TabsContent value="code" className="p-8 w-10/12">
                            <div className="flex flex-col items-center px-6 whitespace-pre-line ">
                                <code className="p-8 border rounded border-gray-600 w-full">
                                    {`
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                                when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                                    It has survived not only five centuries, but also the leap into electronic typesetting, 
                                `} </code>
                            </div>
                        </TabsContent>
                    </Tabs>
                </div>

            </div>
        </section>
    );
};

export default FontColor
